import { range } from "@prismicio/editor-support/Array"
import {
  Box,
  Card,
  CardContent,
  FileUploadButton,
  FormSearchInput,
  Skeleton,
} from "@prismicio/editor-ui"

import { MediaLibraryLayout } from "../MediaLibraryLayout"
import { MediaLibraryActionsContainer } from "./MediaLibraryActions"
import { MediaListScrollArea } from "./MediaList"
import { SidepaneContainer } from "./Sidepane/components/SidepaneContainer"
import { DefaultSidepaneContent } from "./Sidepane/DefaultSidepaneContent"
import { AssetCount } from "./Toolbar/AssetCount"

interface MediaLibrarySkeletonProps {
  actionContainer?: Element | null
}

export function MediaLibrarySkeleton(props: MediaLibrarySkeletonProps) {
  const { actionContainer } = props

  return (
    <MediaLibraryLayout
      sidePane={<MediaLibrarySidePaneSkeleton />}
      mediaActions={
        <MediaLibraryActionsSkeleton actionContainer={actionContainer} />
      }
      mediaToolbar={
        <Skeleton color="grey5" borderRadius={12}>
          <AssetCount count={888} />
        </Skeleton>
      }
      mediaList={<MediaListSkeleton />}
    />
  )
}

function MediaListSkeleton() {
  return (
    <MediaListScrollArea>
      {range(1, 24).map((num) => (
        <MediaCardSkeleton key={num} />
      ))}
    </MediaListScrollArea>
  )
}

interface MediaLibraryActionsSkeleton {
  actionContainer?: Element | null
}
function MediaLibraryActionsSkeleton(props: MediaLibraryActionsSkeleton) {
  const { actionContainer } = props

  return (
    <MediaLibraryActionsContainer actionContainer={actionContainer}>
      <Box width="100%" gap={16}>
        <Box width="100%" flexDirection="column">
          <FormSearchInput
            placeholder="Search"
            maxLength={200}
            value=""
            disabled
            onValueChange={() => {}}
          />
        </Box>

        <FileUploadButton
          disabled
          onFilesSelected={() => {}}
          startIcon="cloudUpload"
          color={actionContainer ? "purple" : "grey"}
          size="large"
        >
          Upload media
        </FileUploadButton>
      </Box>
    </MediaLibraryActionsContainer>
  )
}

function MediaLibrarySidePaneSkeleton() {
  return (
    <SidepaneContainer hasSelectedMedia={false}>
      <DefaultSidepaneContent
        onFilesUpload={() => {}}
        isUploading={false}
        isInitialLoad
      />
    </SidepaneContainer>
  )
}

export function MediaCardSkeleton() {
  return (
    <Card variant="outlined" padding={16}>
      <CardContent gap={0}>
        <Skeleton height={185} width="100%" />
        <Skeleton height={16} width="100%" sx={{ marginTop: 12 }} />
        <Skeleton height={10} width={100} sx={{ marginTop: 8 }} />
        <Skeleton
          height={1}
          width="100%"
          sx={{ marginTop: 20, marginBottom: 16 }}
        />
        <Box flexDirection="row" gap={8}>
          <Skeleton height={24} width={54} />
          <Skeleton height={24} width={45} />
          <Skeleton height={24} width={62} />
        </Box>
      </CardContent>
    </Card>
  )
}
